import React, { Component } from 'react';

import Step from '../../components/step/Step';

import _Fetch from '../../common/Fetches';

const STEP_MENU = ['Gallery'];

const instarImg = '/img/galleryInstaLogo.png';
const INSTA_PROFILE_URL = 'https://www.instagram.com/gloveworks_official/';

// 갤러리 미디어는 glove-server 프록시에서 수신.
// 토큰/프록시가 운영 서버에만 있어 로컬 dev 도 운영 프록시 사용.
const GALLERY_API = {
  url: 'https://server.gloveworks.net/gloveworks/restapi/gallery/instagram',
  method: 'GET',
};

const PLAY_ICON =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" opacity="0.92">' +
      '<path d="M8 5v14l11-7z"/></svg>',
  );

// 반응형 그리드 (모바일 2열 ~ 와이드 5열).
const GRID_CSS = `
.ig-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:14px;width:100%;max-width:1180px;margin:40px auto 0;padding:0 16px;box-sizing:border-box;}
@media(min-width:600px){.ig-grid{grid-template-columns:repeat(3,1fr);gap:16px;}}
@media(min-width:900px){.ig-grid{grid-template-columns:repeat(4,1fr);gap:18px;}}
@media(min-width:1200px){.ig-grid{grid-template-columns:repeat(5,1fr);}}
.ig-cell{display:block;text-decoration:none;}
.ig-tile{position:relative;width:100%;padding-top:100%;background-size:cover;background-position:center;background-repeat:no-repeat;background-color:#000;}
.ig-cell:hover .ig-tile{opacity:.85;transition:opacity .15s ease;}
`;

// VIDEO 는 media_url 이 mp4 라 background 불가, thumbnail_url 사용.
function pickDisplayUrl(item) {
  if (item.media_type === 'VIDEO') return item.thumbnail_url || item.media_url;
  return item.media_url || item.thumbnail_url;
}

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      loading: true,
    };
  }

  componentDidMount() {
    this.load();
  }

  async load() {
    try {
      const res = await _Fetch(GALLERY_API, '?limit=15', []);
      const items = res && Array.isArray(res.data) ? res.data : [];
      this.setState({ items, loading: false });
    } catch (e) {
      // 오류 시 별도 메시지 없이 빈 화면.
      console.error('gallery load failed', e);
      this.setState({ items: [], loading: false });
    }
  }

  renderItem(item) {
    const url = pickDisplayUrl(item);
    const isVideo = item.media_type === 'VIDEO';
    const tile = (
      <div className="ig-tile" style={{ backgroundImage: `url(${url})` }}>
        {isVideo && (
          <span style={styles.videoBadge}>
            <img src={PLAY_ICON} alt="video" style={{ width: 22, height: 22, display: 'block' }} />
          </span>
        )}
      </div>
    );
    if (item.permalink) {
      return (
        <a className="ig-cell" key={item.id} href={item.permalink} target="_blank" rel="noopener noreferrer">
          {tile}
        </a>
      );
    }
    return <div className="ig-cell" key={item.id}>{tile}</div>;
  }

  renderBody() {
    const { items, loading } = this.state;
    if (loading) return <div style={styles.placeholder}>Loading…</div>;
    if (!items.length) return null; // 오류/빈 피드: 별도 메시지 없이 빈 화면
    // 전역 index.css 의 .gallery-item-box{display:flex!important}(<=1024px)가 grid 를 덮어써
    // 모바일에서 타일이 0px 로 접힘. 충돌 회피 위해 ig-grid 단독 사용.
    return (
      <div className="ig-grid">
        {items.map(it => this.renderItem(it))}
      </div>
    );
  }

  render() {
    return (
      <div className="gallery-container">
        <style>{GRID_CSS}</style>
        <Step menu={STEP_MENU} />
        <p className="gallery-title" style={styles.title}>GALLERY</p>
        {/* 인스타 로고 클릭 시 gloveworks_official 새 탭 */}
        <a
          href={INSTA_PROFILE_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={styles.instaLink}
          title="@gloveworks_official"
        >
          <img src={instarImg} style={styles.img} alt="Gloveworks Instagram" />
        </a>
        {this.renderBody()}
        <div style={{ height: 120, clear: 'both' }} />
      </div>
    );
  }
}

const styles = {
  title: {
    fontFamily: 'Roboto Condensed',
    fontSize: 24,
    lineHeight: 1.33,
    letterSpacing: 1.5,
    color: '#251f1b',
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: 50,
  },
  instaLink: {
    display: 'block',
    width: 164,
    margin: '20px auto 0',
  },
  img: {
    width: 164,
    height: 40,
    display: 'block',
    cursor: 'pointer',
  },
  videoBadge: {
    position: 'absolute',
    top: 10,
    right: 10,
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: 'rgba(0,0,0,0.55)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  placeholder: {
    width: '100%',
    maxWidth: 720,
    margin: '60px auto 160px',
    padding: '0 16px',
    textAlign: 'center',
    color: '#666',
    fontFamily: 'Roboto, sans-serif',
    fontSize: 14,
    lineHeight: 1.6,
  },
};

export default Gallery;
